<div :class="{'disabled': disabled}">
    <recurring v-model="recurring" @input="updateRecurring" :start-date="spend.settlement_date" :disabled="disabled"/>
</div>